module.exports = __webpack_public_path__ + "static/img/main-location-icon3.0e076c1a.svg";